//@ts-nocheck
import React from "react";
import PrivateRoutes from "../utils/PrivateRoute";
import ProtectedRoutes from "../utils/ProtectedRoutes";
import { useGetLoggedInUser } from "../api/loggedinUser";

export function GuestGuard({ browseWithoutLogin, isConfigLoading }: { browseWithoutLogin?: boolean; isConfigLoading?: boolean }) {
  // This wraps the existing PrivateRoutes logic or adapts to it.
  // PrivateRoutes currently uses <Outlet />. We can either use it as a layout route or an element wrapper.
  return <PrivateRoutes browseWithoutLogin={browseWithoutLogin} isConfigLoading={isConfigLoading} />;
}

export function AuthGuard({ children, loggedInUser }: { children: React.ReactNode, loggedInUser?: any }) {
  // Wraps the existing ProtectedRoutes logic
  const { isLoading } = useGetLoggedInUser();
  return <ProtectedRoutes loggedInUser={loggedInUser} isLoading={isLoading}>{children}</ProtectedRoutes>;
}
